import { css } from '@emotion/react';
import { Menu, MenuButton, MenuItem, styled, Theme, Typography } from '@mui/joy';
import { NavLink } from 'react-router-dom';

import { LEFT_MENU_WIDTH } from 'theme/constants';

interface IMenuItemProps {
  active?: boolean;
}

const propsToSkip: PropertyKey[] = ['active'];
const shouldForwardProp = (propName: PropertyKey) => !propsToSkip.includes(propName);

const menuItemStyle = (theme: Theme, style = {}, active = false) =>
  css({
    ...style,

    display: 'flex',
    width: LEFT_MENU_WIDTH,
    padding: 16,
    flexDirection: 'column',
    alignItems: 'center',
    gap: 6,
    color: theme.palette.neutral[600],

    svg: {
      width: 24,
      height: 24,
    },

    p: {
      color: 'inherit',
    },

    ':not(:active):hover': {
      backgroundColor: 'inherit',
      color: theme.palette.primary.softColor,
      cursor: 'pointer',
    },

    ':active': {
      color: theme.palette.primary.softColor,
      backgroundColor: theme.palette.primary[100],
      borderRight: `1px solid ${theme.palette.primary.softColor}`,

      ':hover': {
        backgroundColor: `${theme.palette.primary[100]} !important`,
      },
    },

    ...(active && {
      color: theme.palette.primary.softColor,
      backgroundColor: theme.palette.primary[100],
      borderRight: `1px solid ${theme.palette.primary.softColor}`,

      ':hover': {
        backgroundColor: `${theme.palette.primary[100]} !important`,
      },
    }),
  });

export const Wrapper = styled(NavLink, { shouldForwardProp })<IMenuItemProps>(({ theme, active }) =>
  menuItemStyle(theme, {}, active)
);

export const MenuButtonWrapper = styled(MenuButton, { shouldForwardProp })<IMenuItemProps>(
  ({ theme, active }) =>
    menuItemStyle(
      theme,
      {
        border: 'none',
        borderRight: 'inherit',
        borderRadius: 0,
        backgroundColor: 'inherit',
      },
      active
    )
);

export const Label = styled(Typography)({
  lineHeight: '155%',
  fontWeight: 600,
});

export const SubMenuWrapper = styled(Menu)({
  display: 'inline-flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 1,
  borderRadius: 6,
  paddingBlock: 0,
});

export const SubMenuItemWrapper = styled(MenuItem)({
  display: 'flex',
  padding: 0,
  alignItems: 'center',
  gap: 12,
  lineHeight: '100%',
  fontWeight: 600,

  '&.MuiMenuItem-root:not(.Mui-selected, [aria-selected="true"])': {
    ':hover': {
      cursor: 'pointer',
    },
  },
});
